var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconDropoffDone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 8,
    height: 9,
    viewBox: "0 0 8 9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-32 -531) translate(16 393) translate(16 12) translate(0 105) translate(0 13) translate(0 8)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8.214,
    fill: "#009B62",
    rx: 2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    stroke: "#FFF",
    d: "M3.514 6.16c.1 0 .178-.045.234-.134L5.942 2.45c.042-.07.058-.122.058-.178 0-.132-.084-.218-.211-.218-.093 0-.144.03-.2.122l-2.085 3.44-1.081-1.467c-.059-.084-.117-.118-.2-.118-.132 0-.223.094-.223.226 0 .056.023.118.067.176L3.272 6.02c.07.094.142.14.242.14z"
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDropoffDone);
export default __webpack_public_path__ + "static/media/icon-dropoff-done.db29d76abe40a7b047d4d25a849ad903.svg";
export { ForwardRef as ReactComponent };